import React from 'react';
import copy from 'copy-to-clipboard';
import styled, { css } from 'styled-components';
import { Box, Button, Textarea } from '@freenow/wave';
export const ShowHideAnimationWrapper = styled.div `
    overflow: hidden;
    ${({ isOpen }) => css `
        max-height: ${isOpen ? 300 : 0}px;
        opacity: ${isOpen ? 1 : 0};
    `};
    transition:
        max-height 0.3s linear,
        opacity 0.3s linear;
`;
export const DropdownItems = ({ isOpen, buttonTitle, errorText }) => (React.createElement(ShowHideAnimationWrapper, { isOpen: isOpen },
    React.createElement(Box, { display: "flex", flexDirection: "column", justifyContent: "space-around", alignItems: "center" },
        React.createElement(Textarea, { value: errorText, readOnly: true }),
        React.createElement(Button, { mt: "2", onClick: () => copy(errorText) }, buttonTitle))));
